import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import {withStyles} from "material-ui";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <div className={classes.container}>
        <div className={classes.left} style={{padding: '15px 0'}}>
        <a
          href="https://unsplash.com/@verneho?utm_medium=referral&amp;utm_campaign=photographer-credit&amp;utm_content=creditBadge" target="_blank"
          rel="noopener noreferrer"
          title="Download free do whatever you want high-resolution photos from Verne Ho"
          className={aClasses}
        >
          Credits
        </a>
        </div>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear()} , criado por Vítor Magano
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/views/Nodizurc/Components/Footer.jsx